import React, { useState } from "react";
import InterfaceComponent from "../Masters/InterfaceComponent";
import { ActionHandlerProvider } from "../../Components/ActionHandlerContext";
import { useRef } from "react";
import { FormInstance, Modal, Table } from "antd";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { API } from "../../Axios/Axios";
import { getRequestHistory } from "../../Helpers/APIEndpoints/Endpoints";

dayjs.extend(utc);
dayjs.extend(timezone);

const RequestDashboard = () => {
  const formRef = useRef<FormInstance>(null);
  const navigate = useNavigate();
  const [interfaceName, setInterfaceName] = useState<any>("Request Dashboard");
  const [historyData, setHistoryData] = useState<any>([]);
  const [isHistoryIconClicked, setIsHistoryIconClicked] = useState(false);

  const formatToLocal = (utcDate: string) => {
    return dayjs.utc(utcDate).local().format("DD-MM-YYYY hh:mm A");
  };

  const Historycolumns = [
    {
      title: "Timestamp",
      dataIndex: "timestamp",
      key: "timestamp",
      render: (value: string) => formatToLocal(value),
    },
    {
      title: "Role",
      dataIndex: "role",
    },
    {
      title: "Username",
      dataIndex: "username",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      render: (value: string) => value || "-",
    },
    {
      title: "TAT",
      dataIndex: "tat",
    },
  ];

  const handleHistoryClose = () => {
    setIsHistoryIconClicked(false);
    setHistoryData([]);
  };

  const interfaceActionHandler = {
    customJsonMethod: async (apiValues: any, fieldName: any) => {
      console.log("customJsonMethod called");
      let value = {
        testMarks: 32358,
      };

      return value;
    },
  };

  const interfaceFieldActionHandler = {
    hideShowTabsOnFieldChange: async (form: any) => {
      let formData: Record<string, any>;
      if ("getFieldsValue" in form) {
        formData = form.getFieldsValue();
      } else {
        formData = form;
      }
      console.log(formData);
    },
  };
  const rowActionHandler = {
    DynamicMasterRowView: async (...params: any[]) => {
      console.log(`${params[1]} action with parameters:`, params);
      console.log("rowActionHandler");
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      return true;
    },
    DynamicMasterRowEdit: async (...params: any[]) => {
      // console.log(`${params[1]} action with parameters:`, params);
      console.log("rowActionHandler Edit 44", params);
      // await new Promise((resolve) => setTimeout(resolve, 3000));
      navigate("/RequestDetailInterface", {
        state: {
          //id: params[1].interfaceId,
          // id : 8,
          actionType: "Edit",
          RId: params[1].RId,
          Mode: "Edit",
          // TaskDetailId: params[1].TaskDetailId,
        },
      });
      return true;
    },
    DynamicMasterRowDelete: async (type: string, record: any) => {
      try {
        // let response = await API.post(deleteRecordById, {
        // Id: record.Key,
        // });
        // if (response.data) {
        // console.log("Deleted successfully.");
        // await formRef.current!.reloadDashboard();
        // } else {
        // console.error("Failed to delete");
        // }
      } catch (error) {
        console.error(`Failed to perform`, error);
        // resolve(false);
      } finally {
        console.error("Finally block");
      }
    },
    HandleTaskSelectNavigation: async (...params: any[]) => {
      console.log(`${params[1]} action with parameters:`, params);
      console.log("HandleTaskSelectNavigation", params[1]);
      navigate("/RequestDetailInterface", {
        state: {
          actionType: "Edit",
          RId: params[1].RequestNumber,
          Mode: "Edit",
          TaskDetailId: params[1].RId,
          TabId: 6,
        },
      });

      return true;
    },
    History: async (...params: any[]) => {
      console.log("history");
      try {
        const obj = {
          Id: params[1].RId,
        };
        const res = await API.post(getRequestHistory, obj);
        console.log("history res ==>", res);

        if (res?.data?.data?.length > 0) {
          setHistoryData(res?.data?.data);
        }

        setIsHistoryIconClicked(true);
      } catch (error) {
        console.error("History API Error:", error);
      }
    },
  };

  // Hetal Code
  //   const LoadInnerInterface = async () => {
  //     setInterfaceName("Request Details Interface");
  //     console.log("load method called");
  //   };

  const reportActionHandler = {
    DynamicReportActionCreate: async (...params: any[]) => {
      // console.log(`${params[1]} action with parameters:`, params);
      console.log("reportActionHandler", params);

      navigate("/RequestDetailInterface", {
        state: {
          //id: params[1].interfaceId,
          //id: 8,
          actionType: "Create",
          RId: 0,
          Mode: "Create",
          // inter
        },
      });

      await new Promise((resolve) => setTimeout(resolve, 3000));
      return true;
    },
  };

  return (
    <>
      <ActionHandlerProvider
        rowActionHandler={rowActionHandler}
        interfaceActionHandler={interfaceActionHandler}
        interfaceFieldActionHandler={interfaceFieldActionHandler}
        reportActionHandler={reportActionHandler}
      >
        <InterfaceComponent
          InterfaceName={interfaceName}
          DashboardName={""}
          actionType={"DynamicFormActionCreate"}
          RId={null}
          Mode={"Create"}
          //handleCancel={handleCancel}
          ref={formRef}

          ////Hetal Code
          //   LoadInnerInterface={LoadInnerInterface}
          //   onSuccess= {(() => {
          //     setInterfaceName("Request Dashboard");
          //   })}
        />
      </ActionHandlerProvider>

      <Modal
        title="Request History"
        open={isHistoryIconClicked}
        onOk={handleHistoryClose}
        onCancel={handleHistoryClose}
        footer={null}
        width={800}
        destroyOnClose
      >
        <Table
          columns={Historycolumns}
          dataSource={historyData || []}
          pagination={false}
          rowKey="id"
        />
      </Modal>
    </>
  );
};

export default RequestDashboard;
